// @ts-check
import React, { PureComponent } from "react";
import Window from "../Window";
import DontTouchMe from "../DontTouchMe";
import Hits from "../Hits";
import Insults from "../Insults";

const isShortHeight = window.matchMedia("(max-height: 710px)").matches;
const createSequence = (start = 0, fn) => value => (start = fn(start, value));
const createPositionSequence = start =>
  createSequence(start, (acc, add) => ({ x: acc.x + add.x, y: acc.y + add.y }));
const position = createPositionSequence({
  x: 150,
  y: isShortHeight ? 30 : 150
});

const genSpeed = (min, max) => min + Math.random() * (max - min);
const pause = async delayMs =>
  new Promise(resolve => setTimeout(resolve, delayMs));

const until = (conditionCheck, interval = 500) =>
  Promise.resolve(
    conditionCheck() || pause().then(() => until(conditionCheck, interval))
  );

const windowsSmallWindows = [
  () => "Hi pervert!",
  () => "So you want to play with me",
  () => "I hope you're not another loser",
  () => "Be a good pet",
  () => <strong>Open me on your PC instead</strong>,
  () => "You want the full experience, right?",
  () => "xoxo Princess"
].map((render, i) => ({
  render,
  position: {
    x: 10 + 6 * i,
    y: (isShortHeight ? 20 : 90) + 60 * i
  }
}));

const retryUntilResolved = fn =>
  Promise.resolve(fn()).catch(err => retryUntilResolved(fn));

export default class Introduction extends PureComponent {
  inputs = {};
  state = {
    areWindowsGoingOut: false,
    windows: []
  };

  componentDidMount() {
    if (this.props.deviceIsUnsupported) {
      this.openSmallWindowWarning();
    } else {
      this.intro();
    }
  }

  componentWillReceiveProps(props) {
    if (props.name !== this.props.name) {
      this.handleNameSet();
    }
  }

  openSmallWindowWarning() {
    if (!this.state.alreadyOpenedWindows) {
      windowsSmallWindows.forEach(async (win, i) => {
        await this.openWindow(
          windowsSmallWindows[i],
          300 + 100 * i + (i === 0 ? 0 : 1000)
        );
      });
      this.setState({ alreadyOpenedWindows: true });
    }
  }

  async openWindow(config) {
    if (this.props.isSafewordShouted) {
      // never resolve
      return new Promise(() => {});
    }
    this.setState(state => ({
      windows: [...state.windows, config]
    }));
  }

  closeWindow(index) {
    this.setState(state => ({
      windows: [
        ...state.windows.slice(0, index),
        null,
        ...state.windows.slice(index + 1)
      ]
    }));
  }

  agreeOnSafeword = (field, value) => {
    this.props.setAppState({ isSafewordAgreed: true });
    this.handleSafewordSet();
  };

  intro = async () => {
    await pause(300);
    await this.openWindow({
      render: () => "Hi. I'm Princess",
      position: position({ x: 0, y: 0 })
    });
    await pause(500);
    await this.openWindow({
      field: "name",
      render: () => <strong>Who are you?</strong>,
      confirm: "Ok",
      position: position({ x: 30, y: 70 }),
      onConfirm: (key, value) => this.props.setAppState({ [key]: value })
    });
  };

  handleNameSet = async () => {
    await this.openWindow({
      render: ({ name }) => `${name}?`,
      position: position({ x: 30, y: 70 })
    });
    await pause(1300);
    await this.openWindow({
      render: ({ name }) => `${name} is a shitty name`,
      position: position({ x: 30, y: 70 })
    });
    await pause(400);
    await this.openWindow({
      render: () => "For now you'll be my bitch",
      position: position({ x: 30, y: 70 })
    });
    await pause(400);
    await this.openWindow({
      render: () => "We're gonna have so much fun",
      position: position({ x: 30, y: 70 })
    });
    await pause(2000);
    await this.openWindow({
      render: () => (
        <div>
          Before we start playing though, we need a safeword so I know if I'm
          too rough with you
        </div>
      ),
      position: position({ x: 100, y: -300 })
    });
    await pause(2500);
    await this.openWindow({
      field: "safeword",
      render: () => <strong>Pick a safeword</strong>,
      confirm: "Ok",
      position: position({ x: 30, y: 110 }),
      onChange: (key, value) => this.props.setAppState({ [key]: value }),
      onConfirm: this.agreeOnSafeword
    });
  };

  handleSafewordSet = async () => {
    await pause(1000);
    await this.openWindow({
      render: ({ safeword }) => <strong>Your safeword is {safeword}.</strong>,
      position: position({ x: 30, y: 60 })
    });
    await pause(1500);
    await this.openWindow({
      render: () => (
        <span>
          If you feel like I’m going to far,{" "}
          <strong>just type it in and hit enter</strong>
        </span>
      ),
      position: position({ x: 30, y: 60 })
    });
    await pause(2500);
    await this.openWindow({
      render: () => "Let’s try it once",
      position: position({ x: 30, y: 90 })
    });

    document.addEventListener("keyup", this.handleKeyPress);
  };

  handleKeyPress = e => {
    if (e.target.nodeName.toUpperCase() === "INPUT") return;

    const {
      isSafewordTriedOut,
      safeword,
      safewordTyped,
      setAppState
    } = this.props;
    const key = `${e.key}`.toUpperCase();
    switch (key) {
      case "BACKSPACE": {
        setAppState({ safewordTyped: safewordTyped.slice(0, -1) });
        return;
      }
      case "ENTER": {
        if (safewordTyped.toUpperCase() === safeword.toUpperCase()) {
          if (isSafewordTriedOut) {
            setAppState({ isSafewordShouted: true });
            this.handleSafewordShouted();
          } else {
            setAppState({ safewordTyped: "", isSafewordTriedOut: true });
            this.handleSafewordTriedOut();
          }
        }
        return;
      }
      default: {
        const appendedSafewordTyped = `${safewordTyped}${key}`.toUpperCase();
        if (safeword.toUpperCase().startsWith(appendedSafewordTyped)) {
          setAppState({ safewordTyped: appendedSafewordTyped });
        }
        return;
      }
    }
  };

  handleSafewordTriedOut = async () => {
    await pause(1000);
    await this.openWindow({
      render: () => "Good pet!",
      position: position({ x: 30, y: 90 })
    });
    await pause(2000);
    await this.openWindow({
      render: () => "If you use it again, it will be for real",
      position: position({ x: 205, y: -375 })
    });
    await pause(4000);
    await this.openWindow({
      render: () => "Don’t be shy",
      position: position({ x: 30, y: 90 })
    });
    await pause(2000);
    this.props.setAppState({ webcamEnabled: true });
    await pause(500);
    await this.openWindow({
      render: () => (
        <div>
          <strong>Give me access to your camera</strong> so I can see who I’m
          playing with
        </div>
      ),
      position: position({ x: 30, y: 90 })
    });
    await until(() => this.props.webcamHasBeenStarted);
    await pause(8000);
    await this.openWindow({
      render: () => "Wow look at you, you get so excited by this",
      position: position({ x: -700, y: -290 })
    });
    await pause(500);
    await this.openWindow({
      render: () => "That’s kinda cute ",
      position: position({ x: 30, y: 90 })
    });
    await pause(7000);
    await this.openWindow({
      render: () => "I'm impressed",
      position: position({ x: 30, y: 90 })
    });
    await pause(500);
    await this.openWindow({
      render: () => "You must be one of the ugliest people I’ve seen here",
      position: position({ x: 30, y: 90 })
    });
    await pause(4500);
    await this.openWindow({
      render: () => "Let me just take a photo of you",
      position: position({ x: 30, y: 90 })
    });
    await pause(1500);
    this.props.setAppState({ takePicture: true });
    await pause(7000);
    await this.openWindow({
      render: ({ name }) => `So why did you come to talk to me ${name}?`,
      position: position({ x: 80, y: -310 })
    });
    await pause(2000);
    await this.openWindow({
      render: ({ name }) => `I guess you’re just another lonely pervert`,
      position: position({ x: 30, y: 90 })
    });
    await pause(3500);
    await this.openWindow({
      render: ({ name }) => `Well we can talk`,
      position: position({ x: 30, y: 90 })
    });
    await pause(2000);
    await this.openWindow({
      render: ({ name }) => `But don’t think you’ll ever get to touch me`,
      position: position({ x: 30, y: 90 })
    });
    await pause(3000);
    this.props.pushScene(DontTouchMe);
    await pause(5000);
    await this.openWindow({
      render: ({ name }) => `Yes I know I’m the hottest thing you’ve ever seen`,
      position: position({ x: 65, y: -320 })
    });
    await pause(5000);
    await this.openWindow({
      render: ({ name }) =>
        `Such a shame your filthy, tiny hands will never satisfy me`,
      position: position({ x: 30, y: 90 })
    });
    await pause(5000);
    await this.openWindow({
      render: ({ name }) => `But don’t worry, I have plenty of other options`,
      position: position({ x: 30, y: 90 })
    });
    await pause(2500);
    this.props.setAppState({ youCanTouchMeNow: true });
    await this.openWindow({
      render: ({ name }) =>
        `Oh honey, you thought you are the only one I talk to?`,
      position: position({ x: 30, y: 90 })
    });
    await pause(3000);
    await this.openWindow({
      render: ({ name }) => `These are all the slaves that worship me`,
      position: position({ x: 30, y: 90 })
    });
    await pause(2000);
    this.props.pushScene(Hits);
    await pause(3000);
    await this.openWindow({
      render: ({ name }) => `As you can see, you don’t mean shit to me`,
      position: position({ x: 30, y: 90 })
    });
    await pause(5000);
    await this.openWindow({
      render: ({ name }) =>
        `Actually I think you should introduce me to one of your friends`,
      position: position({ x: -550, y: -320 })
    });
    await pause(3000);
    await this.openWindow({
      render: ({ name }) => `Someone who’s not so fucking pathetic`,
      position: position({ x: 30, y: 90 })
    });
    await pause(500);
    await this.openWindow({
      render: ({ name }) => `Someone who turns me on`,
      position: position({ x: 30, y: 90 })
    });
    await pause(500);
    await this.openWindow({
      render: ({ name }) => `Someone better than you!`,
      position: position({ x: 30, y: 90 })
    });
    position({ x: 640, y: -350 });
    await retryUntilResolved(async () => {
      await pause(1000);
      return new Promise(async (resolve, reject) => {
        await this.openWindow({
          field: "friendsEmail",
          render: () => <strong>Your friends email:</strong>,
          confirm: "Share",
          cancel: "I don't want to share",
          position: position({ x: 30, y: 90 }),
          onConfirm: async (_, email) => {
            this.sendEmail(_, email);
            await pause(500);
            await this.openWindow({
              render: () => `Good pet! Share me with more people!`,
              position: position({ x: 30, y: 90 })
            });
            reject();
          },
          onCancel: () => {
            resolve();
          }
        });
      });
    });
    this.props.setAppState({
      doneSharing: true
    });
    this.handleDoneSharing();
  };

  sendEmail = (_, email = "") => {
    const to = email.trim();
    if (!to) {
      return;
    }
    const name = this.props.name.replace(/\s+/g, "+");

    return fetch(`/.netlify/functions/email?name=${name}&to=${to}`, {
      method: "POST",
      body: JSON.stringify({ name, to }),
      headers: {
        "Content-Type": "application/json"
      }
    }).catch(err => /* ignore err */ null);
  };

  handleSafewordShouted = async () => {
    this.props.setAppState({ safewordTyped: "", safeword: "" });
    this.setState({ areWindowsGoingOut: true });
    await pause(500);
    this.animateWindowsOut();
    await pause(6000);
    this.completeAnimationOut();
  };

  animateWindowsOut = async () => {
    this.setState(
      state => {
        const { windows } = state;
        return {
          windows: windows.filter(Boolean).map(win => {
            const speedY = (win.speedY || genSpeed(0.1, 1.2)) * 1.02;
            let nextY = win.position.y + speedY;
            if (win.position.y > this.props.dimensions.height) {
              nextY = -300;
            }
            return {
              ...win,
              speedY,
              draggable: false,
              position: {
                x: win.position.x,
                y: nextY
              }
            };
          })
        };
      },
      () => {
        if (this.state.areWindowsGoingOut) {
          window.requestAnimationFrame(this.animateWindowsOut);
        }
      }
    );
  };

  completeAnimationOut = async () => {
    this.props.setAppState({ isSafewordShouted: false });
    this.setState({ areWindowsGoingOut: false, windows: [] }, async () => {
      await this.openWindow({
        render: () => "I’m sorry I hurt you",
        position: {
          x: this.props.dimensions.width / 2 - 160,
          y: this.props.dimensions.height / 2 - 55
        }
      });
    });
    await pause(10000);
    // eslint-disable-next-line no-restricted-globals
    location.assign("/");
  };

  async handleDoneSharing() {
    const position = createPositionSequence({ x: 540, y: 140 });
    await pause(1000);
    await this.openWindow({
      render: () => `Are you fucking serious?`,
      position: position({ x: 30, y: 90 })
    });
    await pause(1000);
    await this.openWindow({
      render: () => `You’re such a lonely loser you don’t know anybody?`,
      position: position({ x: 30, y: 90 })
    });
    await pause(1000);
    await this.openWindow({
      render: () => `Or maybe you just don’t want to share me?`,
      position: position({ x: 30, y: 90 })
    });
    await pause(1000);
    await this.openWindow({
      render: () => `Well FUCK YOU!`,
      position: position({ x: 30, y: 90 })
    });
    await pause(1000);
    this.props.pushScene(Insults);
  }

  render() {
    const { windows } = this.state;
    return (
      <div>
        {windows.map(
          (props, i) =>
            props && (
              <Window
                draggable
                {...props}
                getZIndex={this.props.getZIndex}
                key={i}
                onClose={() => this.closeWindow(i)}
              >
                {props.render(this.props)}
              </Window>
            )
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Introduction/index.js